<div class="row">
  <div class="col-md-6">
    <div class="card card-body">
      <div class="row">
        <div class="col-md-3">
          <label for="ports">Select vessel</label>
        </div>
        <div class="col-md-7">
          <select class="form-control"
            name="ports"
            id="ports"
            tabindex="1"
            [(ngModel)]="vessel"
            required>
            @for (v of vessels | async; track $index) {
              <option [ngValue]="v">
                {{v.name.name}}
              </option>
            }
          </select>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3">
          <label for="years">Year</label>
        </div>
        <div class="col-md-7">
          <select class="form-control"
            name="years"
            id="years"
            tabindex="1"
            [(ngModel)]="selectedYear"
            required>
            @for (y of years; track $index) {
              <option [ngValue]="y"> {{y}} </option>
            }
          </select>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3">
          <label for="quarters">Quarter</label>
        </div>
        <div class="col-md-7">
          <select class="form-control"
            name="quarters"
            id="quarters"
            tabindex="1"
            [(ngModel)]="selectedQuarter"
            required>
            @for (q of ['Q1', 'Q2', 'Q3', 'Q4']; track $index) {
              <option [ngValue]="q">
              {{q}} </option>
            }
          </select>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3">
          <label for="dailyCost">Daily cost</label>
        </div>
        <div class="col-md-7">
          <input class="form-control"
            type="numbers"
            name="dailyCost"
            id="dailyCost"
            tabindex="1"
            [(ngModel)]="daily"
            required>
          </div>
        </div>
        <div class="col-md-12 ">
          <button class="btn btn-primary" (click)="addBudget()">Add</button>
        </div>
      </div>
    </div>
    <div class="col-md-6">
      <div class="card card-body">
        <div class="col-md-12 col-xs-12 vh-100">
          <ag-grid-angular
            class="ag-theme-alpine"
            [gridOptions]="gridOptions"
            (gridReady)="gridSetting($event)"
            [columnDefs]="columnDefs"
            [rowData]="budgets"
            [domLayout]="'autoHeight'"
            [pagination]= "true"
            [paginationPageSize]="10"
            [paginationPageSizeSelector]="[10,20,30]"
            [enableCellTextSelection]="true"
            >
          </ag-grid-angular>
        </div>
      </div>
    </div>
  </div>
